module.exports = __webpack_public_path__ + "static/media/29ADMSPC16.5f2bf8df.jpg";